import React from 'react';

const Footer = () => {
    return (
        <footer className="footer h-30 footer-center pb-0 pt-3 p-2 bg-black text-white mt-200">
            <div className='p-10'>
                <p>Copyright © 2022 - All right reserved by Kitchen Food Ltd</p>
            </div>
        </footer>
    );
};

export default Footer;